export const VattiCdrCountDateColumns = [
  { title: "话单日期", field: "cdrDate", width: 120 },
  { title: "星期", field: "weekName", width: 120 },
  { title: "上线人数", field: "activeUsers", width: 120 },
  { title: "人工进线量", field: "manIcv", width: 120 },
  { title: "智能进线量", field: "smartIcv", width: 120 },
  { title: "24H-智能进线量", field: "smartIcv24h", width: 120 },
  { title: "整体进线量", field: "totalIcv", width: 120 },
  { title: "人工接入量", field: "manCh", width: 120 },
  { title: "智能未转人工量", field: "noManSmartCh", width: 120 },
  { title: "智能未转人工占比", field: "noManSmartChRate", width: 120 },
  { title: "智能转人工量", field: "manSmartCh", width: 120 },
  { title: "智能转人工占比", field: "manSmartChRate", width: 120 },
  { title: "整体接入量", field: "totalCh", width: 120 },
  { title: "人工接通率", field: "manChRate", width: 120 },
  { title: "智能接通率", field: "smartChRate", width: 120 },
  { title: "整体接通率", field: "totalChRate", width: 120 },
  { title: "智能下单成功量", field: "successfulOrder", width: 120 },
  { title: "智能下单成功率", field: "successOrderRate", width: 120 }

];

export const VattiCdrCountTimeColumns = [
  { title: "话单日期", field: "cdrDate", width: 120 },
  { title: "时间", field: "timeRange", width: 120 },
  { title: "人工进线量", field: "manIcv", width: 120 },
  { title: "智能进线量", field: "smartIcv", width: 120 },
  { title: "24H-智能进线量", field: "smartIcv24h", width: 120 },
  { title: "整体进线量", field: "totalIcv", width: 120 },
  { title: "人工接入量", field: "manCh", width: 120 },
  { title: "智能未转人工量", field: "noManSmartCh", width: 120 },
  { title: "智能未转人工占比", field: "noManSmartChRate", width: 120 },
  { title: "智能转人工量", field: "manSmartCh", width: 120 },
  { title: "智能转人工占比", field: "manSmartChRate", width: 120 },
  { title: "整体接入量", field: "totalCh", width: 120 },
  { title: "人工接通率", field: "manChRate", width: 120 },
  { title: "智能接通率", field: "smartChRate", width: 120 },
  { title: "整体接通率", field: "totalChRate", width: 120 }
];


export const VattiCdrCountColumns = [
  { title: "话单日期", field: "cdrDate", width: 120 },
  { title: "上线人数", field: "activeUsers", width: 120 },
  { title: "人工进线量", field: "manIcv", width: 120 },
  { title: "智能进线量", field: "smartIcv", width: 120 },
  { title: "24H-智能进线量", field: "smartIcv24h", width: 120 },
  { title: "整体进线量", field: "totalIcv", width: 120 },
  { title: "人工接入量", field: "manCh", width: 120 },
  { title: "智能未转人工量", field: "noManSmartCh", width: 120 },
  { title: "智能未转人工占比", field: "noManSmartChRate", width: 120 },
  { title: "智能转人工量", field: "manSmartCh", width: 120 },
  { title: "智能转人工占比", field: "manSmartChRate", width: 120 },
  { title: "整体接入量", field: "totalCh", width: 120 },
  { title: "人工接通率", field: "manChRate", width: 120 },
  { title: "智能接通率", field: "smartChRate", width: 120 },
  { title: "整体接通率", field: "totalChRate", width: 120 },
  { title: "智能下单成功量", field: "successfulOrder", width: 120 },
  { title: "智能下单成功率", field: "successOrderRate", width: 120 }

];


export const VattiSmartCdrCountColumns = [
  { title: "话单日期", field: "cdrDate", width: 120 },
  { title: "厂家", field: "supplier", width: 120 },
  { title: "业务类型", field: "businessType", width: 120 },
  { title: "智能进线量", field: "smartIcv", width: 120 },
  { title: "未转人工量", field: "noManSmartCh", width: 120 },
  { title: "未转人工占比", field: "noManSmartChRate", width: 120 },
  { title: "转人工量", field: "manSmartCh", width: 120 },
  { title: "转人工占比", field: "manSmartChRate", width: 120 },
  { title: "下单成功量", field: "successfulOrder", width: 120 },
  { title: "下单成功率", field: "successOrderRate", width: 120 }
];
